import { apiClient } from './client';

export type AnnotationType = 'label' | 'line' | 'rectangle' | 'circle' | 'measure';

export interface Annotation {
  id: number;
  hypothesis_id: number;
  type: AnnotationType;
  name?: string | null;
  description?: string | null;
  color?: string | null;
  stroke_width?: number;
  data: any;
  visible: boolean;
  created_at: string;
  updated_at: string;
}

export interface CreateAnnotationDto {
  hypothesis_id: number;
  type: AnnotationType;
  data: any;
  stroke_width?: number;
}

export interface UpdateAnnotationDto {
  type?: AnnotationType;
  name?: string | null;
  description?: string | null;
  color?: string | null;
  stroke_width?: number;
  data?: any;
  visible?: boolean;
}

export const annotationsApi = {
  async getByHypothesis(hypothesisId: number): Promise<Annotation[]> {
    const response = await apiClient.get(`/api/annotations/hypothesis/${hypothesisId}`);
    return response.data;
  },

  async getById(id: number): Promise<Annotation> {
    const response = await apiClient.get(`/api/annotations/${id}`);
    return response.data;
  },

  async create(data: CreateAnnotationDto): Promise<Annotation> {
    const response = await apiClient.post('/api/annotations', data);
    return response.data;
  },

  async update(id: number, data: UpdateAnnotationDto): Promise<Annotation> {
    const response = await apiClient.put(`/api/annotations/${id}`, data);
    return response.data;
  },

  async delete(id: number): Promise<void> {
    await apiClient.delete(`/api/annotations/${id}`);
  },
};
